import request from '@/utils/request'

export interface BulkGrantCleanupListParams {
  tab?: 'pending' | 'removed'
  page?: number
  pageSize?: number
  riskLevel?: 'low' | 'medium' | 'high'
  country?: string
  deviceType?: string
  batchPrefix?: string
  featureId?: number
  activeWithinDays?: number
}

export const listBulkGrantCleanup = (params: BulkGrantCleanupListParams) =>
  request({ url: '/admin/bulk-grant-cleanup', method: 'get', params })

// Filtreye uyan TÜM kullanıcıların user_id'lerini döndürür (sayfadaki değil).
// "Filtreye uyan tümünü seç/kaldır" için kullanılır. data: { userIds, count, total, capped, max }
export const getBulkGrantCleanupMatchingIds = (params: BulkGrantCleanupListParams & { q?: string }) =>
  request({ url: '/admin/bulk-grant-cleanup/matching-ids', method: 'get', params })

export const getBulkGrantCleanupStats = () =>
  request({ url: '/admin/bulk-grant-cleanup/stats', method: 'get' })

export const getBulkGrantCleanupUserDetail = (userId: string) =>
  request({ url: `/admin/bulk-grant-cleanup/users/${userId}`, method: 'get' })

export const revokeBulkGrants = (userIds: string[], reason?: string, featureId?: number) =>
  request({ url: '/admin/bulk-grant-cleanup/revoke', method: 'post', data: { userIds, reason, featureId } })

export const restoreBulkGrants = (userIds: string[], reason?: string) =>
  request({ url: '/admin/bulk-grant-cleanup/restore', method: 'post', data: { userIds, reason } })

export const markBulkGrantVerified = (userIds: string[], reason?: string) =>
  request({ url: '/admin/bulk-grant-cleanup/verify', method: 'post', data: { userIds, reason } })
